import { render, staticRenderFns } from "./PrescriptionListPage.vue?vue&type=template&id=bfdcfd36&"
import script from "./PrescriptionListPage.vue?vue&type=script&lang=ts&"
export * from "./PrescriptionListPage.vue?vue&type=script&lang=ts&"
import style0 from "./PrescriptionListPage.vue?vue&type=style&index=0&id=bfdcfd36&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports